import { useMemo } from "react";
import { sortedCountries, COUNTRY_CONFIG, getCountryByCode } from "../constants/countries";

export const useCountries = () => {
  const countries = useMemo(() => sortedCountries, []);

  const isAreaCodeSupported = useMemo(
    () => (countryCode) => {
      return COUNTRY_CONFIG.AREA_CODE_SUPPORT.includes(countryCode);
    },
    []
  );

  return {
    countries,
    getCountryByCode,
    isAreaCodeSupported,
  };
};
